"use client";

import Markdown from "@/components/atoms/Markdown";
import styles from "./styles.module.scss";
import cn from "clsx";
import { useEffect, useMemo, useState, useRef } from "react";
import strapiSingleAttribute from "@/api/strapiSingleAttribute";
import { ModalTypes } from "@/types/modal";
import {
  OTPContextProvider,
  OTPContextWrapper,
  useOTPContext
} from "@/components/sections/CommonModals/context";

import useOnScreen from "@/helpers/Onscreen";
import ApplicationFormRedirectLoader from "../ApplicationFormRedirectLoader/ApplicationFormRedirectLoader";
import { getGlobalStateValue, updateStateSession } from "@/context/utils";
import { pushToDataLayer } from "@/helpers/gtag";
import { StorageService } from "@/helpers/storage.service";
import CommonButton from "@/components/common/Analytics/CustomButton";
import { StripTextUI } from "@/data/data";
import { usePathname } from "next/navigation";

export default function LandingPageBanner({
  data,
  isMobile,
  isBlueTitle = false,
  showForm = true,
  Component = null,
  formHeading = "Connect with our experts",
  showThankYou = false,
  ProgramId,
  isLandingPage=false,
  associatedPrograms = [],
  isLambdaApi = false,
  slug = ""
}: {
  data?: any;
  isMobile?: boolean;
  isBlueTitle?: boolean;
  showForm?: boolean;
  Component?: any;
  formHeading?: string;
  showThankYou?: boolean;
  ProgramId?: string;
  isLandingPage?: boolean;
  associatedPrograms?: Array<ProgramDetails>;
  isLambdaApi?: boolean;
  slug?:string
}) {
  if (!data?.enabled) return null;
  const [isOtpValidated, setIsOtpValidated]=useState(false);
  const ref = useRef(null);
  const prospectIdRef = useRef(null);
  const emailIdRef = useRef(null);
  const redirectionLinkRef = useRef(null)
  const [clickedInsideLeadForm, setClickedInsideLeadForm] = useState(false);
  const [loadingCount, setLoadingCount] = useState(3);
  const [isApplicationRedirectLoaderDisabled, setApplicationRedirectLoaderDisabled] =
    useState(true);
  const path = usePathname();
  const isAfricaPage = path == "/africa"  
  
  const counterInterval = useRef(null);

  const resetState = () => {
    setIsOtpValidated(false);
    setLoadingCount(3);
    setApplicationRedirectLoaderDisabled(true);
    prospectIdRef.current = null;
  }

  const startLoader = () => {
    counterInterval.current = setInterval(() => {
      setLoadingCount((count) => {
        if (count < 1) {
          clearInterval(counterInterval.current);
          if(isAfricaPage){
            window.location.href = `${redirectionLinkRef.current}${redirectionLinkRef.current ? "&e=1" : ""}`;  
          }else{
            StorageService.set("emailEvent", emailIdRef.current);
            window.location.href = `/thankyou?prospectId=${prospectIdRef.current}`;  
          } 

          setTimeout(() => {
            resetState();
          }, 2000);
          return 0;
        } else {
          return (count - 1);
        }
      });
    }, 1000);
  };

  const imageToRender: any = useMemo(() => {
    const img = isMobile && data?.MobileImage ? data?.MobileImage : data?.Image;
    return strapiSingleAttribute(img);
  }, [data?.Image, isMobile, data?.MobileImage]);


  useEffect(() => {
    updateStateSession({
      formSectionName : formHeading
    });
  }, []);

  useEffect(()=>{
    if(isOtpValidated){
      setApplicationRedirectLoaderDisabled(false)
      startLoader();
    }
    return () => {
      setIsOtpValidated(false);
    }
  },[isOtpValidated]);

  const handleOtpValidation = (_, prospectId, email, link) => {
		setIsOtpValidated(true);
    prospectIdRef.current = prospectId;
    emailIdRef.current = email;
    redirectionLinkRef.current = link;
	};

  const onScreen = useOnScreen(ref);

  useEffect(()=>{
    const stickyElement = document.getElementById('enroll-now-button-cta');

    if(stickyElement){
      if(onScreen){
        stickyElement.style.display = 'none'
      }else{
        stickyElement.style.display = 'block'
      }
    }


  },[onScreen])

  const handleClickInsideLeadForm = (e) => {
    if (!clickedInsideLeadForm) {
      
      pushToDataLayer(
        {
          event :	"lead_initiate",
          cta_text : "NA",
          section_name : "hero_banner",
          header_title :	data?.Title || "NA",
          page_type	: getGlobalStateValue('pageType'),
          page_url : window.location.href || "NA"
        }
      )
      updateStateSession(
        {
          parentSection : "hero_banner"
        }
      )
      setClickedInsideLeadForm(true);
    }
  };

  const handleClickOutsideLeadForm = (e) => {
    const formElement = document.getElementById("new-lead-form");
    if (formElement && !formElement.contains(e.target)) {
      setClickedInsideLeadForm(false); // Reset if clicked outside
    }
  };

  // Add event listener for clicks outside the open lead form
  useEffect(() => {
    
    document.addEventListener("click", handleClickOutsideLeadForm);
    return () => {
      document.removeEventListener("click", handleClickOutsideLeadForm);
    };
  }, []);
  const Custom10PgType = associatedPrograms[0]?.attributes?.BasicDetails?.Custom10PgType || '';
  const programDetails = associatedPrograms[0]?.attributes?.BasicDetails
  const stripText = isMobile ? StripTextUI.mStripTextHTML : StripTextUI.stripTextHTML;
  
  return (
    <div className="container">
       {!isAfricaPage &&  <CommonButton
          GADataNew={{
            event : "lead_initiate",
            cta_text: "Apply_Now",
            section_name: "strip_text_ui",
            header_title: data?.title || "NA",
            page_type: getGlobalStateValue('pageType'),
            page_url : true
          }}
          onClickStorePayload={
            {
              parentSection : "strip_text_ui"
            }
          }
          CTATarget="_self"
          type={"button"}
          modalType={ModalTypes.LandingPageConnectModalTempleteOne}
          scroll={false}
          modalData={{ Custom10PgType,  isMobile, programDetails }}
          isHomePage
          className={styles.stripContainer}
        >
      <div
        
      >
      <div className="font-bold">
        <div
          dangerouslySetInnerHTML={{
            __html: stripText
          }}
        />
      </div>
      </div>
      </CommonButton>}
      <div
        className={cn("relative", styles.root)}
      >
        {!isMobile && (
          <img
            src={imageToRender.url}
            alt={imageToRender.alternativeText || ""}
            className={styles.img}
          />
        )}

       {!isMobile&&( <h1
          className={cn(styles.para, {
            ["!text-primary-blue"]: isBlueTitle,
          })}
        >
          {data?.Title?.replace(/\n/gi, "  \n")}
        </h1>)}
      </div>
   
      <div className={cn("relative", styles.root)}
        style={{
          ...(isMobile && {
            backgroundImage: `url(${imageToRender.url})`,
            backgroundPosition: "center",
            backgroundSize: "cover",
            backgroundRepeat: "no-repeat",
            minHeight: "350px",
            padding: "20px 20px",
            borderRadius: "1rem",
            marginBottom: "20px",
          }),
        }}>
          {isMobile&&( <h1
          className={cn(styles.para, {
            ["!text-primary-blue"]: isBlueTitle,
          })}
        >
          {data?.Title?.replace(/\n/gi, "  \n")}
        </h1>)}
        </div>
        {showForm ? (
        <div ref={ref} id="#leadform" className={styles.form} style={ isAfricaPage ? { top: "1rem" }:{}} onClick={handleClickInsideLeadForm}>
          {isApplicationRedirectLoaderDisabled ? (
            <>
              <Markdown className={styles.formHeading}>{formHeading}</Markdown>
              <OTPContextProvider isLambdaAPI={isLambdaApi}>
                <OTPContextWrapper>
                  <Component
                    slug={slug}
                    showThankYou={showThankYou}
                    isOtpValidated={handleOtpValidation}
                    isLandingPage={isLandingPage}
                    associatedPrograms={associatedPrograms}
                    isLambdaAPI={isLambdaApi}
                  />
                </OTPContextWrapper>

              </OTPContextProvider>
            </>
          ) : (
            <div className={styles.container}>
              <ApplicationFormRedirectLoader redirectTime={loadingCount} text={isAfricaPage?undefined:""} />
            </div>
          )}
        </div>
      ) : null}
    </div>
  );
}
